import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import { AllocationsList } from "./allocationsList";
import { Hierarchy } from "./hierarchy";
import { TagList } from "./tagList";
import styles from "./styles.scss";

function Task(props: Props) {
  return (
    <div className={styles.task}>
      <div className={styles.header}>
        <div className={styles.hierarchy}>
          <Hierarchy />
        </div>
        <AllocationsList />
      </div>
      <Skeleton className={styles.name} />
      <div className={styles.description}>
        <Skeleton className={styles.descriptionText} />
        <Skeleton className={styles.descriptionText} />
        <Skeleton className={styles.descriptionText} />
      </div>
      <div className={styles.tagList}>
        <TagList />
      </div>
    </div>
  );
}

export { Task };
